
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LotCreationGrid extends _Ext.GridBase<LotCreationRow, any> {
        protected getColumnsKey() { return 'Inventory.LotCreation'; }
        protected getDialogType() { return LotCreationDialog; }
        protected getIdProperty() { return LotCreationRow.idProperty; }
        protected getInsertPermission() { return LotCreationRow.insertPermission; }
        protected getLocalTextPrefix() { return LotCreationRow.localTextPrefix; }
        protected getService() { return LotCreationService.baseUrl; }
        rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(93);
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[93].AutoPosting;

            var userDefinition = Q.Authorization.userDefinition;
            this.editItem(<LotCreationRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                TransDate: now.toDateString(),
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 93,
                AutoPosting: autoposting, 

            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}